import * as TYPES from "./Auth.types";
import { getToken } from "../../../utils";

const sessionsPath = "auth";

export const validate = () => ({
  type: TYPES.VALIDATE,
  request: {
    method: "GET",
    url: `${sessionsPath}/check`,
    headers: {
      authorization: getToken(),
    },
  },
});

export const createSession = (user) => ({
  type: TYPES.CREATE_SESSION,
  request: {
    method: "POST",
    url: `${sessionsPath}`,
    data: { authentication: user },
  },
});

export const register = (authentication, callback, errorCallback) => ({
  type: TYPES.REGISTER,
  request: {
    method: "POST",
    url: `${sessionsPath}/register`,
    data: { ...authentication },
  },
  callback,
  errorCallback,
});

export const logout = (callback, errorCallback) => ({
  type: TYPES.LOGOUT,
  request: {
    method: "GET",
    url: `${sessionsPath}/logout`,
    headers: {
      authorization: getToken(),
    },
  },
  callback,
  errorCallback
});

export const clearError = () => ({
  type: TYPES.CLEAR_ERROR,
});

export const getResetPasswordLink = ({email, callback, errorCallback}) => ({
  type: TYPES.GET_RESET_PASSWORD_LINK,
  request: {
    method: "GET",
    url: `${sessionsPath}/reset-password/${email}`,
    headers: { authorization: getToken() },
  },
  callback,
  errorCallback,
})

export const getAccountVerificationLink = ({ callback, errorCallback}) => ({
  type: TYPES.GET_VERIFY_ACCOUNT_LINK,
  request: {
    method: "GET",
    url: `${sessionsPath}/verification`,
    headers: { authorization: getToken() },
  },
  callback,
  errorCallback,
})


export const accountVerification = ({code, callback, errorCallback}) => ({
  type: TYPES.VERIFY_ACCOUNT,
  request: {
    method: "PATCH",
    url: `${sessionsPath}/`,
    data: { code },
    headers: { authorization: getToken() },
  },
  callback,
  errorCallback,
})

export const resetPassword = ({code, newPassword, callback, errorCallback}) => ({
  type: TYPES.RESET_PASSWORD,
  request: {
    method: "PATCH",
    url: `${sessionsPath}/reset-password`,
    data: { code, newPassword },
    headers: { authorization: getToken() },
  },
  callback,
  errorCallback,
})

export const changeAccountPassword = ({ oldPassword, newPassword, callback, errorCallback }) => ({
  type: TYPES.CHANGE_ACCOUNT_PASSWORD,
  request: {
    method: "PATCH",
    url: `${sessionsPath}/password`,
    data: { oldPassword, newPassword },
    headers: { authorization: getToken() },
  },
  callback,
  errorCallback,
})

export const changeTeacherEmail = ({ email, callback, errorCallback }) => ({
  type: TYPES.CHANGE_ACCOUNT_EMAIL,
  request: {
    method: "PATCH",
    url: `${sessionsPath}/email`,
    data: { email },
    headers: { authorization: getToken() },
  },
  callback,
  errorCallback,
})
